import $http from "@/resource";
import utils from "@/utils";
import { Message, Notice } from "view-design";

const $api = {};

/**
 * 获取登入历史
 *
 * @returns {Promise<any>}
 */
$api.getLoginLog = function() {
    const url = "login-history";
    const promise = new Promise(function(resolve) {
        $http.get(url).then(function(response) {
            if (response.code == 200) {
                resolve(response.data);
            } else {
                utils.notice(response.msg, "error");
            }
        });
    });
    return promise;
};

/**
 * 强制退出
 *
 * @param {Object} data 手机、token等信息
 *
 * @returns {Promise<any>}
 */
$api.forceLogout = function(data) {
    const url = "force-logout";
    const promise = new Promise(function(resolve) {
        $http.put(url, data).then(function(response) {
            if (response.code == 200) {
                resolve();
            } else {
                utils.notice(response.msg, "error");
            }
        });
    });
    return promise;
};

/**
 * 业务汇总数据,首页显示所需的各种数据
 *
 * @returns {Promise<any>}
 */
$api.businessStatistics = function() {
    const url = "business-count";
    const promise = new Promise(function(resolve) {
        $http.get(url).then(function(response) {
            if (response.code == 200) {
                resolve(response.data);
            } else {
                utils.notice(response.msg, "error");
            }
        });
    });
    return promise;
};

/**
 * 业务汇总数据,首页显示所需的各种数据
 *
 * @returns {Promise<any>}
 */
$api.getBusinessAreaData = function() {
    const url = "data-statistics";
    const promise = new Promise(function(resolve) {
        $http.get(url).then(response => {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 首页待处理数据汇总
 *
 * @returns {Promise<any>}
 */
$api.getOverdueCount = function() {
    const url = "overdue-count";
    const promise = new Promise(function(resolve) {
        $http.get(url).then(response => {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 首页关注信息数据汇总
 *
 * @returns {Promise<any>}
 */
$api.getFocusCount = function() {
    const url = "focus-count";
    const promise = new Promise(function(resolve) {
        $http.get(url).then(response => {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 首页最新项目数据汇总
 *
 * @returns {Promise<any>}
 */
$api.getLastItem = function() {
    const url = "last-item";
    const promise = new Promise(function(resolve) {
        $http.get(url).then(response => {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取业务区数据列表
 *
 * @param {Number} page 页码
 * @param {Number} page_size 每页数量
 * @param {String} searchTime 搜索时间(当前/两周前/两周后)
 * @param {String} sid 待回看数据/回复我的数据（waitLookBack/replyMe）
 * @param {String} orderWord 列表排序方式
 *
 * @returns {Promise<any>}
 */
$api.getWitingData = function(page, page_size, searchTime, sid, orderWord, type) {
    const url = `data-list?page=${page}&page_size=${page_size}&searchTime=${searchTime}&sid=${sid}&orderWord=${orderWord}&type=${type}`;
    const promise = new Promise(function(resolve) {
        $http.get(url).then(response => {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取首页待处理列表
 *
 * @param {Number} page 页码
 * @param {Number} page_size 每页数量
 * @param {String} status 搜索进程选项
 * @param {String} timeTag 搜索时间选项
 * @param {String} sid 四个tab页面数据
 * @param {String} orderWord 列表排序方式
 * @param {String} nexttime 回访时间
 * @param {String} makeGroup 处理部门
 * @param {String} makeUser 处理人
 * @param {String} type 类型 （0全部，2载体，1项目）
 *
 * @returns {Promise<any>}
 */
$api.getWaitDoing = function(
    page,
    pageSize,
    status,
    timeTag,
    sid,
    orderWord,
    nexttime,
    makeGroup,
    makeUser,
    type
) {
    const url = `wait-doing?page=${page}&page_size=${pageSize}&status=${status}&timeTag=${timeTag}&sid=${sid}&orderWord=${orderWord}&nexttime=${nexttime}&makeGroup=${makeGroup}&makeUser=${makeUser}&type=${type}`;
    const promise = new Promise(function(resolve) {
        $http.get(url).then(response => {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取首页紧急待处理列表
 *
 * @param {String} type 类型0-全部1-项目2-载体
 * @param {Number} page 页码
 * @param {Number} pageSize 每页数量
 * @param {Number} emergency 是否紧急
 * @param {String} timeTag 搜索时间选项
 * @param {String} sid 两个tab页面数据
 * @param {String} orderWord 列表排序方式
 *
 * @returns {Promise<any>}
 */
$api.getUrgentUnprocessed = function(
    type="0",
    page,
    pageSize,
    emergency,
    timeTag,
    sid,
    orderWord
) {
    const url = `at-doing?type=${type}&page=${page}&page_size=${pageSize}&emergency=${emergency}&timeTag=${timeTag}&sid=${sid}&orderWord=${orderWord}`;
    const promise = new Promise(function(resolve) {
        $http.get(url).then(response => {
            resolve(response);
        });
    });
    return promise;
};
// business-statistics

export default $api;



// WEBPACK FOOTER //
// ./src/service/index/home.js